import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IconButton, makeStyles } from '@material-ui/core';
import { DeleteRounded as DeleteIcon } from '@material-ui/icons';

import { User } from '../../../users/types/user.type';
import { UserSearchTable } from '../../../users/components/Tables/UserSearchTable.component';
import { CreateOrganizationFormValues } from './create-organization-form.type';

type Props = {
  watch: UseFormWatch<CreateOrganizationFormValues>;
  setValue: UseFormSetValue<CreateOrganizationFormValues>;
};

const useStyles = makeStyles({
  selectedMembers: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },
  memberChip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.25rem 0.5rem',
    borderRadius: 4,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
});

export function MembersStep({ watch, setValue }: Props) {
  const classes = useStyles();
  const selectedMembers = watch('selectedMembers');
  const selectedMemberIds = selectedMembers.map((m) => m.id);

  const handleAddMember = (user: User) => {
    if (selectedMemberIds.includes(user.id)) return;
    setValue('selectedMembers', [...selectedMembers, user]);
  };

  const handleRemoveMember = (userId: string) => {
    setValue(
      'selectedMembers',
      selectedMembers.filter((m) => m.id !== userId)
    );
  };

  return (
    <>
      <UserSearchTable selectedMemberIds={selectedMemberIds} onAddMember={handleAddMember} maxHeight="30svh" />
      {selectedMembers.length > 0 && (
        <section className={classes.selectedMembers}>
          <h4>
            {selectedMembers.length} membre{selectedMembers.length > 1 ? 's' : ''} s&eacute;lectionn&eacute;
            {selectedMembers.length > 1 ? 's' : ''}
          </h4>
          {selectedMembers.map((member) => (
            <div key={member.id} className={classes.memberChip}>
              <span>
                {member.firstname} {member.lastname} — {member.email}
              </span>
              <IconButton size="small" onClick={() => handleRemoveMember(member.id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          ))}
        </section>
      )}
    </>
  );
}
